import React from 'react';
import { Form, Label, Dropdown } from 'semantic-ui-react';
import { isMobile, isTablet } from 'react-device-detect';

const DropDownSearchInput = ({input, loading, noResultsMessage, placeholder, multiple, options, meta: {touched, error}}) => {
  return (
    <Form.Field error={touched && !!error}>
      <Dropdown
        {...input}
        onChange={(e, data) => input.onChange(data.value)}
        placeholder={placeholder}
        options={options}
        multiple={multiple}
        fluid 
        selection
        search
        loading={loading}
        noResultsMessage={noResultsMessage}
        icon="search"
        className='icon'
        onBlur={() => {}}
        pointing={ (isMobile || isTablet ) ? 'bottom' : 'top' }
      />
      {touched && error && <Label basic color='red'>{error}</Label>}
    </Form.Field>
  )
}

export default DropDownSearchInput;
